module.exports = __webpack_public_path__ + "static/img/map3.3737678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map3.png
// module id = eB+V
// module chunks = 0